// The SDK password is the SCRAM credential for the app's Kafka user. The
// operator writes it into the Secret the KafkaUser references and into the SDK
// config the driver reads, so nobody ever has to type or remember it.
//
// It used to default to '' for a new app, which Strimzi rejects ("The requested
// user password is empty") -- the KafkaUser never became Ready and the pipeline
// could not authenticate. And when loading existing state it fell back to a
// HARDCODED literal, which shipped in the public JS bundle and was shared by
// every app that hit the fallback. Both are replaced by a fresh random value.
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

// Alphanumeric only: the value lands in a Kubernetes Secret, a ConfigMap and a
// SCRAM config, and none of those should need escaping.
export function generateSdkPassword(length = 32): string {
  // Rejection sampling: 248 is the largest multiple of 62 below 256, so
  // discarding bytes >= 248 keeps every character equally likely.
  const out: string[] = [];
  const buf = new Uint8Array(64);
  while (out.length < length) {
    crypto.getRandomValues(buf);
    for (const b of buf) {
      if (b < 248 && out.length < length) out.push(ALPHABET[b % ALPHABET.length]);
    }
  }
  return out.join('');
}
